<template>
  <v-row class="mt-8 category-banner elevation-1">
    <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-start">
      <div>All Categories</div>
    </v-col>
    <v-col cols="12" md="3">
      <ProductSearchBar />
    </v-col>
    <v-col cols="12" md="3" class="d-flex align-center justify-center justify-md-start">
      <v-btn v-if="isKid" text link :to="{ name: 'CartOverview' }" class="body-text-medium">
        <v-icon left size="17">fas fa-shopping-cart</v-icon>
        Cart
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
  import ProductSearchBar from "@/components/Catalog/ProductSearchBar";

  export default {
    name: "CategoryBanner",

    computed: {
      isKid() {
        return this.$store.getters.userInfo.role === "child";
      },
    },

    components: { ProductSearchBar },
  };
</script>

<style lang="scss" scoped>
  .category-banner {
    padding: 0% 10%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Catalog/CategoryBanner.vue